<template>
    <div v-show="tablePagination && tablePagination.last_page > 1" class="pagination">
        <a @click="loadPage(1)"
           :class="['btn-nav', customcss.linkClass, isOnFirstPage ? customcss.disabledClass : '']">
            <i class="mdi mdi-chevron-double-left"></i>
        </a>
        <a @click="loadPage('prev')"
           :class="['btn-nav', customcss.linkClass, isOnFirstPage ? customcss.disabledClass : '']">
            <i v-if="customcss.icons.next != ''" :class="[customcss.icons.prev]"></i>
            <span v-else>&nbsp;&lsaquo;</span>
        </a>
        <template v-if="notEnoughPages">
            <template v-for="n in totalPage">
                <a @click="loadPage(n)"
                   :class="[customcss.pageClass, isCurrentPage(n) ? customcss.activeClass : '']"
                   v-html="n">
                </a>
            </template>
        </template>
        <template v-else>
            <template v-for="n in windowSize">
                <a @click="loadPage(windowStart+n-1)"
                   :class="[customcss.pageClass, isCurrentPage(windowStart+n-1) ? customcss.activeClass : '']"
                   v-html="windowStart+n-1">
                </a>
            </template>
        </template>
        <a @click="loadPage('next')"
           :class="['btn-nav', customcss.linkClass, isOnLastPage ? customcss.disabledClass : '']">
            <i v-if="customcss.icons.next != ''" :class="[customcss.icons.next]"></i>
            <span v-else>&rsaquo;&nbsp;</span>
        </a>
        <a @click="loadPage(totalPage)"
           :class="['btn-nav', customcss.linkClass, isOnLastPage ? customcss.disabledClass : '']">
            <i v-if="customcss.icons.last != ''" :class="[customcss.icons.last]"></i>
            <span v-else>&raquo;</span>
        </a>
    </div>
</template>

<script>

  import VuetablePaginationMixin from "vuetable-2/src/components/VuetablePaginationMixin";

  export default {
    mixins: [VuetablePaginationMixin],

    data() {
      return {
        customcss: {
          wrapperClass: "pagination",
          activeClass: "active",
          disabledClass: "disabled",
          pageClass: "page",
          linkClass: "link",
          icons: {
            first: "mdi mdi-chevron-double-left",
            prev: "mdi mdi-chevron-left",
            next: "mdi mdi-chevron-right",
            last: "mdi mdi-chevron-double-right"
          }
        }
      };
    }

  };

</script>